import React, { useEffect, useState } from 'react';
import CardProduct from '../CardProduct/CardProduct';
import axios from 'axios';

const Watches = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        console.log("Fetching products...");
        const response = await axios.get("http://localhost:3000/api/products");
        const WatchesData = response.data.filter(product => product.categoryId === "watches");
        setProducts(WatchesData);
      } catch (error) {
        console.error("Error fetching Watches products:", error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="products">
    {products.map((product, index) => (
      <CardProduct
        key={index}
        product={product}
      />
    ))}
  </div>
  );
};

export default Watches;
